import React, {useRef, useState, useEffect} from 'react'
import './privateAlbum.css';
import { Link } from 'react-router-dom'
import xButton from './../assets/xButton.png'
import noProfile from './../assets/noprofile.png'
import ExtraOptions from './../extraOptions/extraOptions.js';
import noImage from './../assets/noImage.png'
import like from './../assets/like.png'
import newComment from './../assets/newComment.png'
import rightButton from './../assets/rightButton.png'
import firebase from './../../config/fbConfig.js'

const db = firebase.firestore();

function PrivateAlbum(props) {
	const forceUpdate = React.useState()[1].bind(null, {})
	const [profile, setProfile] = useState({})
	//renderTimes is used to determine correct/proper album value, that's why settingMissingAlbum only on from first render as it is in useEffect
	const renderTimes = useRef(0)
	
	useEffect(() => {
		renderTimes.current++;
		if (renderTimes.current==1) {
			if (props.album.length===0) {
			for (let i=1; i<=12; i++) {
					props.missingAlbum.push("")
					}
				props.setMissingAlbum(props.missingAlbum);
				forceUpdate();
			}	
		}
		if (props.user!=null) {
			db.collection("accounts").doc(props.user.uid).get().then((doc) => {
					    if (doc.exists) {
					        setProfile({
					        	nickname: doc.data().nickname,
					        	pic: doc.data().pic!=null ? doc.data().pic : false,
					        	countryIMG: doc.data().countryIMG
					        }) 
					    }
					    })
			}
	}, [props.user])
	let showPost = (e) => {
		if (e.target.tagName=='DIV') {
			e.target.parentNode.nextSibling.hidden = false;
			let ulList = e.target.parentNode.nextSibling.children[2].firstChild.lastChild;
			for (let i =0; i<(ulList.children.length); i++) {
				if (ulList.children[i].offsetHeight>120) ulList.children[i].style.paddingBottom = '25px';
				}
			}
		else {
			e.target.parentNode.parentNode.nextSibling.hidden = false;
			let ulList = e.target.parentNode.parentNode.nextSibling.children[2].firstChild.lastChild;
			for (let i =0; i<(ulList.children.length); i++) {
				if (ulList.children[i].offsetHeight>120) ulList.children[i].style.paddingBottom = '25px';
				}
		}
		document.body.style.overflow = 'hidden';
	}

	let closePost = (e) => {
		e.target.parentNode.hidden = true;
		document.body.style.overflow = 'visible';
	}

	let LikeFunction = (e) => {
		if (props.user==null) {
			alert("You must be signed in to use this feature.")
			return;
		}
		let specificPost = e.target.parentNode.parentNode.parentNode.dataset.id;
		
		db.collection("feed").doc(specificPost).get().then((doc) => {
			let postCreatorID = doc.data().userID;
			// This index is used to make if the user already liked the post or not, -1 = didn't like
			let index = doc.data().likes.findIndex(i => i.userID === props.user.uid);

			// In case the like isn't in the list(-1 = not found), so need to increment the likes
			if (index == -1) {
				let arr = doc.data().likes;
				arr[0]++;
				arr.push({profilePic: props.profile.pic!=undefined ? props.profile.pic : 'https://i.imgur.com/pDcFnDX.png', nickname: props.profile.nickname, userID: props.user.uid});
				db.collection("feed").doc(specificPost).update({likes: arr});
				db.collection("album").doc(postCreatorID).collection("album").doc(specificPost).update({likes: arr});
				
				// This index is used to find the specific post in the feed in order to update it later
				let indexAlbum = props.album.findIndex(i => i.timestamp === specificPost);
				props.album[indexAlbum] = {...props.album[indexAlbum], likes: arr};
				props.setAlbum(props.album);

				forceUpdate();
				
			} else {
				// This means it was found that the user already liked this post, so decrementing the likes
				let arr = doc.data().likes;
				arr[0]--;
				arr.splice(index, 1);
				
				db.collection("feed").doc(specificPost).update({likes: arr});
				db.collection("album").doc(postCreatorID).collection("album").doc(specificPost).update({likes: arr});
				
				// This index is used to find the specific post in the feed in order to update it later
				let indexAlbum = props.album.findIndex(i => i.timestamp === specificPost);
				props.album[indexAlbum] = {...props.album[indexAlbum], likes: arr};
				props.setAlbum(props.album);

				forceUpdate();
				
			}
		})

	}
	let showNewComment = (e) => {
		if (props.user==null) {
			alert("You must be signed in to use this feature.")
			return;
		}
		e.target.nextSibling.nextSibling.hidden = !e.target.nextSibling.nextSibling.hidden;

		if (window.innerWidth<1030) {
			if (!e.target.nextSibling.nextSibling.hidden) e.target.nextSibling.nextSibling.nextSibling.style.borderTop = "none";
			else e.target.nextSibling.nextSibling.nextSibling.style.borderTop = "5px solid black";
		}
		

	}
	let sendComment = (e) => {
		let targ;
		if (e.target.tagName=="IMG") {
			targ = e.target.parentNode
		} else {
			targ = e.target;
		}
		
		const specificPost = targ.parentNode.parentNode.parentNode.parentNode.dataset.id;
		// const postCreatorID = e.target.parentNode.parentNode.parentNode.children[0].dataset.id;
		let postCreatorID;
		(props.match!=undefined) ? postCreatorID = props.match.params.profile_id : postCreatorID = props.user.uid;
		
		// Get current time's format
		let timeNow = firebase.firestore.Timestamp.fromDate(new Date()).seconds;
		let dateFormat = new Date(timeNow*1000);
		let firstPart = dateFormat.toLocaleDateString("en-GB");
		let hours = "";
		let minutes = "";

		if (dateFormat.getHours()<10) {
		  	hours = "0" + dateFormat.getHours();
		} else { hours = dateFormat.getHours();	}
		if (dateFormat.getMinutes()<10) {
		  	minutes = "0" + dateFormat.getMinutes();
		} else { minutes = dateFormat.getMinutes();	}

		dateFormat = `${firstPart} ${hours}:${minutes}`;
		

		if (targ.previousSibling.value.length < 4) {
			alert('You need to enter at least 4 characters for a message.')
		} else {
			let deliveredComment = {
				userID: props.user.uid,
				dateFormat: dateFormat,
				nickname: profile.nickname,
				profilePic: profile.pic!=false ? profile.pic : 'https://i.imgur.com/pDcFnDX.png',
				countryIMG: profile.countryIMG,
				data: targ.previousSibling.value
			}
					
			let index = props.album.findIndex(i => i.timestamp === specificPost);
			props.album[index].comments.push(deliveredComment);
			props.setAlbum(props.album);
			forceUpdate();

			
			// Inject the comment inside the feed's specific post document
			db.collection('feed').doc(specificPost).update({
				comments: firebase.firestore.FieldValue.arrayUnion(deliveredComment)
			});

			// Inject the comment inside the private album's feed
			db.collection("album").doc(postCreatorID).collection('album').doc(specificPost).update({
				comments: firebase.firestore.FieldValue.arrayUnion(deliveredComment)
			});		

			targ.parentNode.hidden = true;
			if (window.innerWidth<1030) {
				targ.parentNode.nextSibling.style.borderTop = '5px solid black';
			}
		}
		
	}

	return (
		<div id="album">
		{props.album!=null && props.album.map(post => 
					<React.Fragment key={post.timestamp}>

					<div className="post">
						<div className="frame" onClick={showPost}>
							<span className="helper"></span><img src={post.link} alt="Post" draggable='false'/>
						</div>

					</div>

					<div className="hiddenPost" hidden data-id={post.timestamp}>
							<img className="closeButton" src={xButton} onClick={closePost}/>
							<div className="wrapperIMG">
								<span className="helper"></span><img src={post.link}/>
								{props.user!=null ? <ExtraOptions likesLength={post.likes.length} postLikes={post.likes} isPhone={props.isPhone} user={props.user} userID={props.match.params.profile_id} forceUpdate={forceUpdate} feed={null} setFeed={null} album={props.album} setAlbum={props.setAlbum} missingAlbum={props.missingAlbum} setMissingAlbum={props.setMissingAlbum}/> 
								: <ExtraOptions likesLength={post.likes.length} postLikes={post.likes} isPhone={props.isPhone} user={props.user} userID={null} forceUpdate={props.forceUpdate} feed={null} setFeed={null} album={props.album} setAlbum={props.setAlbum} missingAlbum={props.missingAlbum} setMissingAlbum={props.setMissingAlbum}/> }
							</div>

							<div className="content">

								<div className="contentBox">
									<div className="timePosted">{post.dateFormat}</div>
									{props.profile.pic!=false ? <img src={props.profile.pic} alt="Profile pic"/> : <img src={noProfile} alt="profile pic"/>}
									<div className="nickname">{props.profile.nickname} says:</div>
									<div className="title">{post.title}</div>
									<div className="desc">{post.desc}</div>
									<img src={like} className="likesButton" onClick={LikeFunction}/>
									<span className="likes">{post.likes[0]} likes</span>
									<img src={newComment} style={{float: 'none'}} className="newComment" onClick={showNewComment}/>
									
									<span className="comments">{post.comments.length} comments</span>

									<div className="hiddenComment" hidden>
										{profile.pic!=false ? <img className="profile" src={profile.pic} alt="Profile pic"/> : <img className="profile" src={noProfile} alt="profile pic"/>}
										<div className="nick">{profile.nickname}
										<img className="country" src={profile.countryIMG} alt="Country" style={{left: 'auto'}}/>
										</div>
										<textarea placeholder="Enter your comment here"/>
										<button onClick={sendComment}><img src={rightButton} alt="->"/></button>
									</div>

									<ul>
									{post.comments!=null && post.comments.map((comment, index) => 
										<li key={index}>
											{/* need to add {comment.userID} for profile click later*/}
											{(comment.profilePic!=false) ? <img className="profile" src={comment.profilePic} alt="Profile Pic"/> :  <img className="profile" src={noProfile} alt="no profile"/>}
											<img className="country" src={comment.countryIMG} alt="Country" style={{maxHeight: 'initial'}}/>
											<div className="nick"><Link to={'/profile/' + comment.userID} onClick={() => setTimeout(() => window.location.reload(), 0)}>{comment.nickname}</Link>
											</div>
											<div className="text">{comment.data}</div>
											<div className="timeComment">{comment.dateFormat}</div>
										</li>
									)}
									{post.comments.length==0 && <li style={{textAlign: 'center', paddingTop: '5vh', fontSize: '30px'}}>No comments :(</li>}
									</ul>
									

								</div>

							</div>

					</div>

					</React.Fragment>
			)}

				{props.missingAlbum.map((missing, index) =>
					 		<div className="post" key={index}>

								<div className="frame" style={{backgroundColor: 'rgba(255,192,203,0.4)' , cursor: 'no-drop'}}>
								<span className="helper"></span><img src={noImage} style={{opacity: 0.5}} alt="No Pic" draggable="false"/>
								</div>
							</div>
					 )}
		</div>
	)
}

export default PrivateAlbum